import { Component, OnInit, AfterViewInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import { ItemComponent } from "../app-home-work/home-work-item/item.component";
@Component({
  selector: 'app-home-work-show',
  templateUrl: './home-work-show.component.html',
  styleUrls: ['./home-work-show.component.css']
})

export class HomeWorkShowComponent implements OnInit, AfterViewInit {
  @ViewChild('child')
  child: ItemComponent
  tabList: any
  className: string = 'response'
  tabNum: number = 0
  isElseTeacherEvaluate: boolean = true //学员作答是否有顾问点评
  myComment: string = "" //我的作答顾问第一次点评
  myQuetionComment: string = "" //我的作答顾问第二次点评
  submitAt: string = "" //学员提交时间
  excellentFlag: number  // 是否是优秀
  isComment: boolean = false //是否有评论
  studentList: any = null//学员作答
  myData: any = null //我的作答
  exerciseGroup: any
  isOpenClass: number = 0; //是否公开课
  constituteId: number
  page: string; //页面
  bodyHeight: string; //答题模块的高度
  appreciateCount: number
  selectedTag: string = ""
  collapse: boolean = true
  relationIdArr: any = [] //学员作答relationId
  answerGroup: any = [] //学员作答答案
  theme: string = 'sight'
  appreciateList: any = []
  quertion: any
  isShowToast: boolean = false;
  destext: string = "您已经点过赞了"
  data: any = {}
  showCount: boolean = false //在自己没点赞情况下展示点赞次数(大于0展示)
  ifshowData: boolean = false
  isOnlyCamp: boolean = false //只有训练营
  isLastDay: boolean = false //是否是day7
  isFirstDay: any //是否是第一天
  uploadList: any; //上传文件集合
  uploadId: string = ""; //查询上传文件条件
  isShowPreview: boolean = false; //是否显示预览
  previewSource: any; //预览源
  comment: any;//评论内容
  back: any;//评论返回（保存评论内容）
  myCommentList: any;//我的作答评论数据
  relationId: any;
  commentFlag: any;
  learningPathId: any;
  courseId: any;
  text: string = "";
  isShowBackDesc : boolean = false;//是否展示背景描述
  lpmapcId : number;//试卷id
  exerciseType: number; //练习类型
	projectId : any;
  learningPathMetaId : any;
  homeworkCloseAtFlag : number = 0;//作答时间是否截止
  homeworkNoAnswer : number = 0;//作业是否未作答
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private commonService: CommonService,
    private router: Router,) {
  }

  ngOnInit() {
    this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
    this.tabList = ['我的作答', '学员作答']
    this.route.params.subscribe(params=>{
      this.lpmapcId = params['lpmapcId'];
    })
    this.route.queryParams.subscribe(queryParams => {
      this.tabNum = queryParams['tabNum'];
      this.learningPathMetaId = queryParams['learningPathMetaId'];
      this.projectId = queryParams['projectId'];
      this.homeworkCloseAtFlag = Number(queryParams['homeworkCloseAtFlag']);
    })
    if(this.learningPathMetaId){
      localStorage.setItem("learningPathMetaId",this.learningPathMetaId);
    }else{
      localStorage.setItem("learningPathMetaId","");
    }
    localStorage.removeItem("moduleId");

    this.test();
  }

  async test(){
    this.exerciseGroup = await this.getExerciseDetail(this.lpmapcId);//题目数据
    console.log('作业数据',this.exerciseGroup);
    this.homeworkNoAnswer = this.exerciseGroup.status <= 10 ? 0 : 1;
    this.myData = await this.getMyAnswerEvaluate(this.lpmapcId);//我的作答数据
    await this.getStudentList();//学员作答数据
    this.appreciateList = await this.getAppreciate();//获取点赞列表
    await this.mockData();
  }

  getStudentList(){
    return this.getStudentAnswers(this.lpmapcId).then(result=>{
      this.studentList = result.studentAnswerVOList;
    })
  }

  mockData(){
    let self = this;
    this.exerciseType = this.exerciseGroup.homeworkAppendixList.length === 0 ? 1 : 5;
    this.ifshowData = true;
    this.myData.userClick = false;
    this.exerciseGroup.str = this.exerciseGroup.userAnswer;
    //我的作答自己是否点赞判断
    self.appreciateList.forEach(item => {
      if (item.userHomeworkRelationId == self.myData.relationId) {
        self.myData.userClick = true;
      }
    })
    //学员作答自己是否点赞情况判断
    self.studentList.forEach(item=>{
      self.appreciateList.forEach(itm => {
        if (item['userCampExerciseQuestionOperationLogVO'].relationId == itm.userHomeworkRelationId) {
          item.userClick = true
        }
      })
    })
    setTimeout(() => {
      this.judjeHeight();
    }, 100);
  }

  //判断高度是否达到可展开收拢高度
  judjeHeight(){
    if(this.tabNum == 0){
      this.myData.showOpen = 0;
      const exerciseWorkBox = document.getElementById(`exercise-work-box-${this.myData.relationId}`);
      if (this.myData.comment != '' && this.myData.comment != null && exerciseWorkBox && exerciseWorkBox.offsetHeight>220) {  // 有评论且高度达到
        this.myData.showOpen = 1
      }
    }else if(this.tabNum == 1){
      this.studentList.forEach(item=>{
        item.showOpen = 0;
        // 有评论且高度达到
        const exerciseWorkBox = document.getElementById(`exercise-work-box-${item['userCampExerciseQuestionOperationLogVO'].relationId}`);
        if (item['userCampExerciseQuestionOperationLogVO'].comment != "" && item['userCampExerciseQuestionOperationLogVO'].comment != null && exerciseWorkBox && exerciseWorkBox.offsetHeight>200) {
          item.showOpen = 1
        }
      })
    }
  }

  //背景描述
  backgroundDesc(){
    this.isShowBackDesc = !this.isShowBackDesc;
  }

  getLearningPathMetaId(){
    //根据LearningPathMetaId判断获取是第几单元为了外链进入到作答页面后返回课程列表页是第几单元
    if(this.isFirstDay){
      if(Number(localStorage.getItem("campId")) === 1 || Number(localStorage.getItem("campId")) === 3){
        localStorage.setItem("campCourseDay","Start Day");
      }else{
        localStorage.setItem("campCourseDay","Day1");
      }
    }else if(this.isLastDay){
      if(Number(localStorage.getItem("campId")) === 1){//标准版
        localStorage.setItem("campCourseDay","综合检测");
        localStorage.setItem("learningPathMetasId","-49601");
      }else if(Number(localStorage.getItem("campId")) === 3){//大健康
        localStorage.setItem("campCourseDay","综合检测");
        localStorage.setItem("learningPathMetasId","-429601");
      }else{//互联网
        localStorage.setItem("campCourseDay","Day14");
        localStorage.setItem("learningPathMetasId","-419601");
      }
    }else{
      if(this.learningPathId){
        this.apiService.ajax({
          'type': 'get',
          'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
        }).subscribe(result=>{
          switch(result.data){
            case 4192: localStorage.setItem("campCourseDay","Day2&3"); break;
            case 492 || 4292: localStorage.setItem("campCourseDay","沟通原则"); break;
            case 412: localStorage.setItem("campCourseDay","Day4&5"); break;
            case 402 || 422: localStorage.setItem("campCourseDay","互动流程"); break;
            case 416: localStorage.setItem("campCourseDay","Day6&7"); break;
            case 406 || 426: localStorage.setItem("campCourseDay","目标设定"); break;
            case 413: localStorage.setItem("campCourseDay","Day8&9"); break;
            case 403 || 423: localStorage.setItem("campCourseDay","任务授权"); break;
            case 415: localStorage.setItem("campCourseDay","Day10&11"); break;
            case 405 || 425: localStorage.setItem("campCourseDay","辅导他人"); break;
            case 4196: localStorage.setItem("campCourseDay","Day12&13"); break;
            case 496 || 4296: localStorage.setItem("campCourseDay","绩效追踪"); break;
          }
        })
      }
    }
  }


  ngAfterViewInit() {
    this.commonService.initPage({
      'backgroundColor': 'rgba(40,51,130,1)'
    });
  }

  /**
   * 获取答题界面用户上传列表
   * @param tabNum: Number  nav下标
   */
  getAnswerUploadList(tabNum: number): void {
    if (tabNum === 0) {
      let index = this.commonService.getIndexByConditionIdInLists(this.exerciseGroup['questionGroup'], 'type', 5);
      if (index >= 0) {
        this.uploadId = this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] ? this.exerciseGroup['questionGroup'][index]['campFileUploadIds'] : '';
        this.getCampFile({ 'constituteId': this.constituteId, 'questionId': this.exerciseGroup['questionGroup'][index]['questionId'], 'campFileUploadIds': this.uploadId }).then((result) => {
          this.uploadList = result['newFileList'];
        })
      } else {
        this.uploadList = [];
      }
    }
  }

  async tabIndex(i) {
    this.ifshowData = false;
    this.tabNum = i;
    //切换tab时滚动到顶部
    await this.test();
    $('.wrap').scrollTop(0);
  }
  //我的作答展开
  myOpen(flag) {
    this.myData.showOpen = flag == 1? 2 : 1;
    //点击收拢的时候回到顶部
    if(this.myData.showOpen == 1){
      //跳转到对应位置
      let ele = document.querySelector(`.my`);
      ele.scrollTop = 0;
    }
  }
  studentOpen(relationId) {
    this.studentList.map(item => {
      if (item['userCampExerciseQuestionOperationLogVO'].relationId == relationId) {
        item.showOpen = item.showOpen == 1? 2 : 1;
      }
    })
    //跳转到对应位置
    let ele = document.querySelector(`.comment_wrap-${relationId}`);
    ele.scrollIntoView();
  }

  //返回
  exit() {
    let learningPathMetaId = null
    let projectId = null;
    this.route.queryParams.subscribe(queryParams => {
      learningPathMetaId = queryParams['learningPathMetaId'];
      projectId = queryParams['projectId'];
    })
    localStorage.setItem("projectId",this.exerciseGroup.projectId);
    if(learningPathMetaId){
      this.router.navigate(['learning-path', learningPathMetaId]);
    }else{
      this.router.navigate(['learning-project', projectId]);
    }
  }

  setBodyHeight(event: number): void {
    this.bodyHeight = event + 'rem';
  }
  //我的作答点赞
  getMyAppreciate() {
    this.myData.appreciateCount += 1;
    this.myData.userClick = true;
  }
  //学员点赞
  getStudentAppreciate(obj) {
    obj.studentList.map(item => {
      if (item['campExerciseQuestionGroupMetaVO'].relationId == obj.relationId) {
        item['userCampExerciseQuestionOperationLogVO'].appreciateCount = item['userCampExerciseQuestionOperationLogVO'].appreciateCount += 1
        item.userClick = true
      }
    })
    this.studentList = obj.studentList
  }

  getShowToast(flag) {
    this.isShowToast = flag
    if (this.isShowToast) {
      setTimeout(() => {
        this.isShowToast = false
      }, 2000)
    }
  }
  //点赞
  giveAppreciate(data) {
    return this.apiService.ajax({
      'type': 'post',
      'url': '/ddilearner/v2/user/project/homework/saveOperationLog',
      'data': data
    }).toPromise();
  }
  //点赞列表
  getAppreciate() {
    return this.apiService.ajax({
      'type': 'get',
      'url': 'ddilearner/v2/user/project/homework/getOperationLogList/3',
    }).toPromise();
  }

  //获取上传文件列表
  getCampFile(data) {
    return this.apiService.ajax({
      'type': 'POST',
      'url': 'ddilearner/v2/user/project/homework/getHomeworkFileList',
      'data': data
    }).toPromise();
  }

  //根据试卷ID获取当前试卷所有小题题目
  getExerciseDetail(lpmapcId): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/project/homework?homeworkDuplicateId=' + lpmapcId,
    }).toPromise();
  }

  //获取我的作答数据
  getMyAnswerEvaluate(lpmapcId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/project/homework/getMyAnswer/' + lpmapcId
    }).toPromise();
  }

  //获取学员作答数据
  getStudentAnswers(lpmapcId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/project/homework/getStudentAnswer/' + lpmapcId
    }).toPromise();
  }
  /**
   * 预览
   * @param event:Object   子组件传递来的预览对象
   */
  showReview(event): void {
    console.log(11111111111111);
    this.previewSource = event;
    this.isShowPreview = true;
  }

  /**
   * 关闭预览
   */
  closePreview(): void {
    this.isShowPreview = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-show.component.ts